import React from 'react';
import { colors } from '../../constants/colors';

const Cancellation = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: colors.dark_blue, height: "100vh" }}>
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "20px",
          borderRadius: "10px",
          width: "90%",
          height: "90%",
          overflowY: "scroll",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
          Eventyol Cancellation and No-Show Policy
        </h1>
        <h2>Cancellation notice</h2>
        <p>Clients must provide at least 24 hours' notice to cancel.</p>
        <h2>Late cancellations</h2>
        <p>Clients who cancel within 24 hours of their appointment may be charged full service cost.</p>
        <h2>Late arrivals</h2>
        <p>Clients who arrive late may be asked to not participate in the activity.</p>
        <h2>No-shows</h2>
        <p>Clients who don't show up without notice may be charged the full service cost.</p>
        <h2>Repeat no-shows</h2>
        <p>Clients who miss multiple activities may be required to prepay for future activities or may not be able to book future activities.</p>
        <h2>Exceptions</h2>
        <p>Businesses may make exceptions to their policy on a case-by-case basis for emergencies, weather conditions, or special circumstances.</p>
        <h2>Acknowledgment and Agreement</h2>
        <p>
          I have read and understand this Cancellation and No-Show Policy. I recognize that by signing or otherwise acknowledging this document, I waive certain legal rights and voluntarily agree to these terms.
        </p>
      </div>
    </div>
  );
};

export default Cancellation;